<template>
  <div v-if="contract.id && wrapItem.length > 0" class="b-t-1-869fb229">
    <h5 class="py-2">{{ title }}</h5>
    <div v-for="(item, i) in wrapItem" class="row px-2" :key="i">
      <div class="col-md-6 px-1">
        <div class="form-detail">
          <div
            class="alert alert-warning pl-1"
            role="alert"
            v-if="
              item.appendixDevice &&
              item.appendixDevice.isCashback === true &&
              ['HOUSEHOLD', 'COMPANY'].includes(contract.typeCustomer) &&
              contract.groupService === 'PAYMENT'
            "
          >
            Cashback
          </div>
          <div
            class="alert alert-warning pl-1"
            role="alert"
            v-if="
              item.appendixLend &&
              item.appendixLend.isCashback === true &&
              ['HOUSEHOLD', 'COMPANY'].includes(contract.typeCustomer) &&
              contract.groupService === 'PAYMENT'
            "
          >
            Cashback
          </div>
          <div
            class="alert alert-warning pl-1"
            role="alert"
            v-if="item.appendixDevice && item.appendixDevice.isLend === true"
          >
            Cho mượn
          </div>
          <div
            class="alert alert-success pl-1"
            role="alert"
            v-if="item.appendixDevice && item.appendixDevice.isRent === true"
          >
            Cho thuê
          </div>
          <b-table
            class="mb-3 mh-125"
            sticky-header
            responsive
            :items="[item]"
            :fields="fields"
            :fixed="true"
            :bordered="true"
          >
            <template #cell(code)="{ item }">
              <p>
                {{ item.code ? item.code : '' }}
              </p>
              <p>
                {{ item.isRemote && item.isRemote === true ? 'Ký từ xa' : '' }}
              </p>
            </template>
            <template #cell(time)="{ item }">
              <Content title="Ngày tạo">
                {{
                  item.dateCreate || item.dateCreatedAppendixDTO | formatDate('HH:mm DD/MM/YYYY')
                }}
              </Content>
              <Content v-if="item.dateSign || item.dateSignAppendixDTO" title="Ngày ký">
                {{ item.dateSign || item.dateSignAppendixDTO | formatDate('HH:mm DD/MM/YYYY') }}
              </Content>
              <Content v-if="item.dateCancel || item.dateRejectedDTO" title="Ngày huỷ">
                {{ item.dateCancel || item.dateRejectedDTO | formatDate('HH:mm DD/MM/YYYY') }}
              </Content>
            </template>
            <template #cell(state)="{ item }">
              <template v-if="item.typeAppendix === 'LIQUIDATE'">
                <span
                  v-if="!['WAITING_APPROVED_FEE', 'APPROVED_FEE'].includes(item.state)"
                  class="badge"
                  :class="item.state"
                >
                  {{ item.state | mapTextStatus(Config.listStatusContract) }}
                </span>
                <span
                  v-else-if="item.state === 'WAITING_APPROVED_FEE'"
                  class="badge WAITING_LIQUIDATE"
                >
                  Chờ duyệt thanh lý
                </span>
                <span v-else-if="item.state === 'APPROVED_FEE'" class="badge APPROVED_FEE">
                  Đã duyệt thanh lý
                </span>
              </template>
              <span v-else class="badge" :class="item.state">
                {{ item.state | mapTextStatus(Config.listStatusContract) }}
              </span>
              <p v-if="item.reasonRejected.length">Lý do : {{ item.reasonRejected | last }}</p>
              <p v-if="item.noteReasonAddInfo">Lý do : {{ item.noteReasonAddInfo.join(',') }}</p>
            </template>
            <template #cell(detail)="{ item }">
              <slot name="cellDetail" v-bind="item"></slot>
            </template>
            <template #cell(type)="{ item }">
              <span
                v-if="
                  item.appendixDevice &&
                  item.appendixDevice.isCashback === true &&
                  ['HOUSEHOLD', 'COMPANY'].includes(contract.typeCustomer) &&
                  contract.groupService === 'PAYMENT'
                "
              >
                Cashback
              </span>
              <span
                v-if="
                  item.appendixLend &&
                  item.appendixLend.isCashback === true &&
                  ['HOUSEHOLD', 'COMPANY'].includes(contract.typeCustomer) &&
                  contract.groupService === 'PAYMENT'
                "
              >
                Cashback
              </span>
            </template>
            <template #row-details="{ item }">
              <slot name="row-details" v-bind="item"></slot>
            </template>
            <template #cell(mposStt)="{ item }">
              <span
                class="badge mb-1"
                :class="
                  item?.mposStt ? getStatusColor(item?.mposStt, Config.mposSttConfigGured) : ''
                "
              >
                {{ item.mposStt | transformData(Config.mposSttConfigGured) }}
              </span>
              <br />
              <span v-if="item.mposStt === 'REJECT'"> Lý do: {{ item.mposReason }}</span>
            </template>
            <template #cell(stateMpos)="{ item }">
              <span class="badge mb-1" :class="item.mposStt ? item.mposStt : ''">
                {{ item.mposStt | transformData(Config.mposStt) }}
              </span>
              <br />
              <span v-if="item.mposStt === 'REJECT'"> Lý do: {{ item.mposReason }}</span>
            </template>
            <template #cell(action)="{ item }">
              <AppendixAction :actions="actions(item)" :excepts="excepts" :only="only" />
            </template>
          </b-table>
          <div>
            <slot name="footer-card" v-bind="item"></slot>
          </div>
        </div>
      </div>
      <div class="col-md-6 px-1">
        <slot name="file" v-bind="item"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import Content from '../Content.vue'
  import AppendixAction from './AppendixAction.vue'
  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
      _showDetails: {
        type: Boolean,
        default: true,
      },
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      fields: {
        type: Array,
        default() {
          return [
            { key: 'code', label: 'Số phụ lục', class: 'text-left' },
            {
              key: 'time',
              label: 'Thời gian',
              class: 'text-left',
              thStyle: 'min-width: 210px',
            },
            { key: 'state', label: 'Trạng thái', class: 'text-center' },
            { key: 'action', label: 'Thao tác', class: 'text-center action' },
          ]
        },
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { Content, AppendixAction },
    data() {
      return {
        Config,
      }
    },
    methods: {
      getStatusColor(status, optionColorStatus) {
        if (!status) return ''
        return optionColorStatus.find(s => s.id === status).bgColor || status
      },
    },
    computed: {
      wrapItem() {
        return this.items
          .filter(s => s?.appendixHandOver?.receiverHandover !== 'MERCHANT')
          .map(s => {
            s._showDetails = this._showDetails
            return s
          })
      },
    },
  }
</script>

<style scoped>
  ::v-deep .action {
    padding: 15px 0px !important;
  }
</style>
